export default {
	savedSearches: [
		// will be pulled from database
		{ id:-1, labelKey: 'orderSearch.searchForOrders' },
	],
	settingsSavedSearches: [], // separate state for settings to avoid refreshing autosearch count. Rename?
	autoSearches: [],
	searchInterval: {},
	liveUpdateInProgress: false
};
